module.exports = __webpack_public_path__ + "img/download_studio.eafb70b1.png";